// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16tqT","inner":"Footer_inner__2mw5o","nextIcon":"Footer_nextIcon__2ILed","innerLeft":"Footer_innerLeft__3RoEm"};